export const HouseInsuranceRequireModel = [
    {
      formName: 'formProductInsurancePlan',
      fieldRequired: [
        'exploitingType',
        'businessProgramCode',
        'exploitingCode',
        'curencyMoney',
        'curencyFee',
        'exchangeRate',
      ],
    },
    {
      formName: 'formProductHouseInsured',
      fieldRequired: [
        'certType',
        'packageCode',
        'name',
        'ownerType',
        'address',
        'startDate',
        'expireDate',
        'houseType',
        'businessHouseType',
        'fireFighting',
      ],
    },
    {
      formName: 'formProductContract',
      fieldRequired: [
        'contractType',
        'contractNumber',
        'purchaseDate',
        'startDate',
        'endDate',
        'taxType',
      ],
    },
  ]
  